import axios from "@/lib/axios";

export const fetchMyFeatureFlags = async (): Promise<Record<string, boolean>> => {
  const res = await axios.get("/feature-flags/mine");
  return res.data.data.flags;
};
